import React, { useEffect, useState } from 'react'
import Header from '../../../component/Produzioni/Header'
import DashboardCard from '../../../component/Produzioni/DashboardCard';
import InputFeild from '../../../component/Produzioni/InputFeild';
import WeatherCards from '../../../component/Produzioni/WeatherCards';
import { useDispatch, useSelector } from 'react-redux';
import produzioniFormAPI from '../../../services/produzioniFormApi';
import { resetFormSubmit } from '../../../features/produzioniFormData/produzioniFormDataSlice';
import dayjs from 'dayjs';

const Pianificazionedellavendemmia = ({ option, activeStep, setActiveStep }) => {
    const dispatch = useDispatch();
    const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
    const submitForm = useSelector((state) => state.produzioniForm.submitForm);

     const [formData, setFormData] = useState({
        step: activeStep,
        prod_id: singleProduzioneID,
        company_id: Number(localStorage.getItem('company_id')) || "",
        prodotto_id: "",
        date_Start: "",
        date_end: "",
        varieta_dell_uva: "",
        varieta_vigento: "",
        stato: "",
        brix: "",
        acidity: "",
      });

      const fetchDataForUpdate = async () => {
        try {
          const payload = {
            company_id: localStorage.getItem('company_id'),
            step: activeStep,
            prod_id: singleProduzioneID,
          };

          const response = await produzioniFormAPI.getSingleStepFormData(payload);
          // console.log(response,"deklhfisrfo")
          if (response?.data.data.vendemmia?.length) {
            const existing = response.data.data.vendemmia[0];
            setFormData((prev) => ({
              ...prev,
              prod_id: existing.prod_id,
              id: existing.id ,
              date_Start: existing.date_Start ? dayjs(existing.date_Start).format('YYYY-MM-DD') : "",
              date_end: existing.date_end ? dayjs(existing.date_end).format('YYYY-MM-DD') : "",
              prodotto_id: existing.prodotto_id || "",
              varieta_dell_uva: existing.varieta_dell_uva || "",
              varieta_vigento: existing.varieta_vigento || "",
              stato: existing.stato || "",
              brix: existing.brix || "",
              acidity: existing.acidity || "",
            }));
          }
        } catch (error) {
          console.error("Error fetching single step form data:", error);
        }
      };

      useEffect(() => {
          fetchDataForUpdate();
      }, []);

      const onSubmit = async (formData) => {
        const data = {
          step: activeStep,
          forms: {
            vendemmia: [formData]
          }
        };
        try {

            await produzioniFormAPI.updateStepFormData(singleProduzioneID, data);
        
          setActiveStep((prev) => prev + 1);
        } catch (error) {
          fetchDataForUpdate();
          console.error('Error submitting form data:', error);
        }
      };
      useEffect(() => {
        if (submitForm) {
          onSubmit(formData);
          dispatch(resetFormSubmit());
        }
      }, [submitForm, dispatch]);

    const data = {
        id: 1,
        title: "Pianificazione vendemmia",
        description:
            "Organizza la raccolta assicurando che l'uva venga selezionata con cura per preservare la qualità del vino.",
        buttonText: "Completa fase",
    };
    const dummyData = {
        totalCollected: "32.054 Kg",
        discardedGrapes: "3.254 Kg",
        discardPercentage: "10%",
        temperatureCompliance: "OK",
        tasks: [
            "Determinazione della data ottimale di raccolta",
            "Verifica delle condizioni meteorologiche",
            "Analisi del grado di maturazione dell'uva",
            "Assegnazione dei lotti di raccolta"
        ],
    };

    const infoFields = [
        { label: "Q.ta Totale raccolta", key: dummyData.totalCollected },
        { label: "Uva scarta", key: dummyData.discardedGrapes },
        { label: "% Uva scarta", key: dummyData.discardPercentage, showIcon: true },
        { label: "Conformità Temperatura", key: dummyData.temperatureCompliance, showIcon: true },
    ];
    return (
        <>
            <Header data={data} setActiveStep={setActiveStep} activeStep={activeStep} />
            <DashboardCard dummyData={dummyData} infoFields={infoFields} />
            <InputFeild option={option} formData={formData} setFormData={setFormData} />
            <WeatherCards />
        </>
    )
}

export default Pianificazionedellavendemmia